import { inject, Injectable } from '@angular/core';
import { WINDOW } from '@constants/global-objects.constants';

@Injectable({
  providedIn: 'root',
})
export class BrowserService {
  private window = inject(WINDOW);

  constructor() {}

  public open({
    url,
    target,
  }: {
    url: string;
    target?: string;
  }): Promise<void> {
    return new Promise((resolve) => {
      this.window.open(url, target ? target : '_blank');
      resolve();
    });
  }
}
